Prism.languages.ocaml = {
  comment: /\(\*[\s\S]*?\*\)/,
  string: [{
    pattern: /"(?:\\.|[^\\\r\n"])*"/,
    greedy: !0
  }, {
    pattern: /(['`])(?:\\(?:\d+|x[\da-f]+|.)|(?!\1)[^\\\r\n])\1/i,
    greedy: !0
  }],
  number: /\b(?:0x[\da-f][\da-f_]+|(?:0[bo])?\d[\d_]*\.?[\d_]*(?:e[+-]?[\d_]+)?)/i,
  type: {
    pattern: /\B['`]\w*/,
    alias: "variable"
  },
  directive: {
    pattern: /\B#\w+/,
    alias: "function"
  },
  keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|object|of|open|prefix|private|rec|then|sig|struct|to|try|type|val|value|virtual|where|while|with)\b/,
  "boolean": /\b(?:false|true)\b/,
  operator: /:=|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lxor|lsl|lsr|mod|nor|or)\b/,
  punctuation: /[(){}\[\]|_.,:;]/
};